import { Injectable, Pipe, PipeTransform } from '@angular/core'
import { User } from './users.service'
import { constructNameForUser } from './utils'

@Pipe({
  name: 'userName',
  standalone: true,
})
@Injectable({ providedIn: 'root' })
export class UserNamePipe implements PipeTransform {
  transform(user: User): string {
    return constructNameForUser(user)
  }
}
